import { AGENTS, extraModelOption, groupOpenRouterModels, type Agent, type Chat } from '@/mocks/chat';

export function listedModelIds(agentId: Agent['id'], agent: Agent | undefined, models: string[], loadedModels: string[]): string[] {
  if (agentId === 'lmstudio') {
    return [...loadedModels, ...models];
  }
  if (agentId === 'openrouter') {
    return models;
  }
  return agent?.models ?? [];
}

type Props = {
  chat: Chat;
  models: string[];
  loadedModels: string[];
  onSetModel: (model: string) => void;
  className?: string;
};

export default function ModelSelect({ chat, models, loadedModels, onSetModel, className }: Props) {
  const agent = AGENTS.find((a) => a.id === chat.agentId);
  return (
    <select
      data-testid="llm-model"
      value={chat.model}
      onChange={(e) => onSetModel(e.target.value)}
      className={className ?? 'w-full bg-surface/60 border border-border rounded-md px-2.5 py-2 text-sm text-textp outline-none focus:border-accent font-mono'}
    >
      <option value="">{chat.agentId === 'lmstudio' ? 'Select a loaded model' : 'Select a model'}</option>
      {extraModelOption(chat.model, listedModelIds(chat.agentId, agent, models, loadedModels)) && (
        <option value={chat.model}>{chat.model}</option>
      )}
      {chat.agentId === 'lmstudio' ? (
        <>
          {loadedModels.length > 0 && (
            <optgroup label="Loaded in LM Studio">
              {loadedModels.map((m) => (
                <option key={m} value={m}>{m}</option>
              ))}
            </optgroup>
          )}
          {models.filter((m) => !loadedModels.includes(m)).length > 0 && (
            <optgroup label="Downloaded">
              {models.filter((m) => !loadedModels.includes(m)).map((m) => (
                <option key={m} value={m}>{m}</option>
              ))}
            </optgroup>
          )}
        </>
      ) : chat.agentId === 'openrouter' ? (
        groupOpenRouterModels(models).map((g) => (
          <optgroup key={g.label} label={g.label}>
            {g.ids.map((m) => (
              <option key={m} value={m}>{m}</option>
            ))}
          </optgroup>
        ))
      ) : (
        (agent?.models ?? []).map((m) => (
          <option key={m} value={m}>{m}</option>
        ))
      )}
    </select>
  );
}
